import React from 'react';
import { FadeIn } from './FadeIn';
export function FinalCTASection() {
  return <section className="py-24 bg-brand-forest text-white text-center relative overflow-hidden" data-id="element-27">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-28">
        <div className="absolute -top-24 -left-24 w-96 h-96 bg-brand-sage rounded-full blur-3xl" data-id="element-29"></div>
        <div className="absolute -bottom-24 -right-24 w-96 h-96 bg-brand-sage rounded-full blur-3xl" data-id="element-30"></div>
      </div>

      <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-31">
        <FadeIn data-id="element-32">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold mb-6 leading-tight" data-id="element-33">
            Tu mente no está rota.
            <br data-id="element-34" />
            Solo necesita
            <br data-id="element-35" />
            las instrucciones correctas.
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-36">
          <p className="text-xl md:text-2xl text-brand-sage italic mb-12 font-serif" data-id="element-37">
            21 días. 30 módulos. Ciencia real en lenguaje humano.
          </p>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-38">
          <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} className="bg-brand-terracotta text-white px-8 py-4 rounded-full text-lg md:text-xl font-bold hover:bg-opacity-90 hover:scale-105 transition-all duration-300 shadow-xl mb-10 w-full sm:w-auto" data-id="element-39">
            QUIERO MI GUÍA AHORA — $19.99 →
          </button>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-40">
          <div className="flex flex-wrap justify-center gap-6 text-sm font-medium" data-id="element-41">
            <div className="flex items-center gap-2" data-id="element-42">
              <span data-id="element-43">🔒</span> Pago Seguro
            </div>
            <div className="flex items-center gap-2" data-id="element-44">
              <span data-id="element-45">📥</span> Descarga Inmediata
            </div>
            <div className="flex items-center gap-2" data-id="element-46">
              <span data-id="element-47">🧠</span> Basado en Ciencia
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}